<app-soft-deletable-auditable-lookups
  [paginationResponseResolver]="client"
  [defaultPaginationParameters]="defualtPaginationParameters"
  [supportedActions]="supportedActions"
  [tableConfig]="{
    fields: [
      { name: 'code', displayName: 'LOCATION_MANAGEMENT.CODE' },
      { name: translate.currentLang === 'ar' ? 'country.arabicName' : 'country.englishName', displayName: 'GENERAL.COUNTRY' }
    ],
    template: tableRowTemplate
  }"
/>

<ng-template #tableRowTemplate let-element>
  <td>{{ element.code }}</td>
  <td>{{ translate.currentLang === 'ar' ? element.country.arabicName : element.country.englishName }}</td>
</ng-template>
